import config from '@bingads-webui-component-legacy/config/index';
import localStorage from '@bingads-webui-component-legacy/storage/localStorage';

export const isDealCampaign = () => location.pathname.includes('awarenessmediadeal');
export const isCTVCampaign = () => location.pathname.includes('awareness') && !isDealCampaign();

export const getVideoDeal = () => {
  if (!isDealCampaign()) {
    return null;
  }
  let videoDeal = config.get('VideoMediaDeal');
  if (!videoDeal) {
    if (localStorage.supportsStorage()) {
      videoDeal = localStorage.get('VideoMediaDeal');
      config.set('VideoMediaDeal', videoDeal);
    }
  }

  return videoDeal;
};
